import { useContext, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import UserContext from "src/provider/state-manager/userProvider"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AbsoluteContainer, AppLabel, AppSpan, AppText, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenTitle } from "src/style"
import PopupLockIcon from 'src/assets/svg/forgot-password-lock'
import { AppCenterPopup, CenterPopupHeader } from "src/component"
import { BsEyeSlash, BsEye } from "react-icons/bs"
import helpers from "src/utils/helpers"

export const ProfileNewPassword: React.FC<any> = ({close}) => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {logout} = useContext(AppInfoContext)
    const {notifier} = useContext(VisibilityContext)
    const {user: {userInfo}, setUserProperty} = useContext(UserContext)
    const [input, setInput] = useState({oldPin: '', newPin: '', confirmPin: ''})
    const [passwordCheck, setPasswordCheck] = useState({isValidPassword: true, isValidConfirmPassword: true})
    const [showPassword, setShowPassword] = useState({password: false, confirmPassword: false, oldPassword: false})

    const passwordRef = useRef<any>(null)
    const confirmPaswordRef = useRef<any>(null)

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.name === 'newPin' || e.target.name === 'confirmPin') {
            if (e.target.name === 'newPin') passwordRef.current = e.target.value
            if (e.target.name === 'confirmPin') confirmPaswordRef.current = e.target.value
            handleInputCheck()
        }
        setInput({...input, [e.target.name]: e.target.value.trim()})
    }

    function handleInputCheck () {
        let {isValidPassword, isValidConfirmPassword} = passwordCheck
        isValidPassword = helpers.validatePassword(passwordRef.current)
        isValidConfirmPassword = helpers.validatePassword(confirmPaswordRef.current) && passwordRef.current === confirmPaswordRef.current
        setPasswordCheck({isValidPassword, isValidConfirmPassword})
    }
    
    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (!helpers.validatePassword(input.newPin)) return notifier.show('Invalid password. Kindly check the password requirement', 'Validation Response')
        if (input.confirmPin != input.newPin) return notifier.show('Password did not match', 'Validation Response')
        
        const response = await API.changePin_Password(input)
        if (response) {
            await logout()
            navigate('/login')
        }
        else close()
    }
    
    return (
        <AppCenterPopup height='67.1' zIndex='8' close={close}>
            <CenterPopupHeader icon={<PopupLockIcon className='icon-component'/>} />
            <CustomContainer height="55.1" className='popup-content-container'>
                <CustomContainer topMargin="2">
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">Password Change</ScreenTitle>
                    <Form onSubmit={handleSubmit} topMargin='2'>
                        <FormGroup>
                            <label>Current Password</label>
                            <input 
                                placeholder='Enter Current Password' 
                                name='oldPin'
                                value={input.oldPin}
                                type={showPassword.oldPassword ? 'text' : 'password'}
                                onChange={handleInput}
                                autoComplete='off'
                                required
                            />
                            { !showPassword.oldPassword ?
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPassword({...showPassword, oldPassword: true})}
                                    >
                                        <BsEyeSlash/>
                                    </AppSpan>
                                </AbsoluteContainer>
                                :
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPassword({...showPassword, oldPassword: false})}
                                    >
                                        <BsEye/>
                                    </AppSpan>
                                </AbsoluteContainer>
                            }
                        </FormGroup>
                        <FormGroup 
                            borderColor={!passwordCheck.isValidPassword ? '#B42318' : ''}
                            noFocusBorder={!passwordCheck.isValidPassword ? true : false}
                        >
                            <label>New Password</label>
                            <input 
                                placeholder='Enter New Password'
                                name='newPin' 
                                type={showPassword.password ? 'text' : 'password'}
                                value={input.newPin}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                            { !showPassword.password ?
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPassword({...showPassword, password: true})}
                                    >
                                        <BsEyeSlash/>
                                    </AppSpan>
                                </AbsoluteContainer>
                                :
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPassword({...showPassword, password: false})}
                                    >
                                        <BsEye/>
                                    </AppSpan>
                                </AbsoluteContainer>
                            }
                        </FormGroup>
                        <FormGroup 
                            borderColor={!passwordCheck.isValidConfirmPassword ? '#B42318' : ''}
                            noFocusBorder={!passwordCheck.isValidConfirmPassword ? true : false}
                        >
                            <label>Confirm New Password</label>
                            <input 
                                placeholder='Enter Password' 
                                name='confirmPin'
                                type={showPassword.confirmPassword ? 'text' : 'password'}
                                value={input.confirmPin}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                            { !showPassword.confirmPassword ?
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPassword({...showPassword, confirmPassword: true})}
                                    >
                                        <BsEyeSlash/>
                                    </AppSpan>
                                </AbsoluteContainer>
                                :
                                <AbsoluteContainer bottom='1.2' right='1'>
                                    <AppSpan 
                                        color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                        onClick={() => setShowPassword({...showPassword, confirmPassword: false})}
                                    >
                                        <BsEye/>
                                    </AppSpan>
                                </AbsoluteContainer>
                            }
                        </FormGroup>
                        <CustomContainer 
                            radius='0.8' borderColor='#E7F6F5' bgColor='#E7F6F5'
                            padding='2' topPadding='1.5'
                        >
                            <AppLabel textSize='1.2' fontWeight='700' color='#0A756F'>Password Requirements</AppLabel>
                            <CustomContainer topMargin='0.5'>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2' >Password must be at least 8 digits in length</AppText>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2' >Password must contain at least 1 uppercase letter</AppText>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2'>Password must contain at least 1 lowercase letter</AppText>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2'>Password must contain at least 1 special character</AppText>
                                <AppText textSize='1.2' color='#0A756F' bottomPadding='0.2'>Example: Qore@1500$ </AppText>
                            </CustomContainer>
                        </CustomContainer>
                        
                        <Button 
                            width='100' sizeUnit="%" height='4.4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' topMargin="2.5"
                        >
                            Proceed
                        </Button>
                    </Form>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopup>
    )
}